import RuleSetDomainService from "../RuleSet/RuleSet.service";
export default class DuplicateDomainService {
    static fromJSON(json) {
        return Object.assign(Object.assign({}, json), { ruleSet: json.ruleSet && RuleSetDomainService.fromJSON(json.ruleSet) });
    }
}
